import React, { FC, ReactNode } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider as ThemeProviderV5 } from "@mui/material/styles";
import { CacheProvider, EmotionCache } from "@emotion/react";
import { MaterialRTL } from "./MaterialRTL";
import { materialTheme } from "./materialTheme";
import { materialThemeV5 } from "./materialThemeV5";
import { createEmotionCache } from "./createEmotionCache";

interface Props {
  children?: ReactNode;
  // Overridden per-request during SSR (see _document.tsx). Falls back to a
  // single shared client-side cache so this doesn't need threading through
  // every non-Next.js consumer (e.g. Jest, the storybook Decorator).
  emotionCache?: EmotionCache;
}

const clientSideEmotionCache = createEmotionCache();

const MaterialProvider: FC<Props> = ({
  children,
  emotionCache = clientSideEmotionCache,
}) => {
  return (
    <MaterialRTL>
      <ThemeProvider theme={materialTheme}>
        <CacheProvider value={emotionCache}>
          <ThemeProviderV5 theme={materialThemeV5}>{children}</ThemeProviderV5>
        </CacheProvider>
      </ThemeProvider>
    </MaterialRTL>
  );
};

export { MaterialProvider };
